import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsChipSize } from '@levelaccess/design-system';

import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IDSChipCellConfig extends ICellConfig {
  chipColorVariant: DsChipColorVariant;
  chipSize?: DsChipSize;
}

@Component({
  selector: 'table-cell-ds-chip',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `
    <div class="d-flex gap-2 align-items-center">
      @if (config.subText) {
        <div>{{ config.subText }}</div>
      }
      <ds-chip
        #ref
        [text]="config.text"
        [colorVariant]="config.chipColorVariant"
        [size]="config.chipSize || DsChipSize.Default"
      ></ds-chip>
    </div>
  `,
  standalone: false,
})
export class DSChipCellComponent extends BaseCellComponent {
  @Input() public config: IDSChipCellConfig;
  protected readonly DsChipSize: typeof DsChipSize = DsChipSize;
}
